import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges
} from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FlyoutMenuComponent } from '../../../components/flyout-menu/flyout-menu.component';
import { FlyoutMenuToggleDirective } from '../../../components/flyout-menu/flyout-menu-toggle.directive';
import { IconComponent } from '../../../components/icon/icon.component';
import { FlyoutMenuOverlayPosition, MenuPanelItem } from '../../../domain/menu.domain';
import { MenuTopGlobalNavigationItemLabelComponent } from './top-navigation-item-label.component';

import type { FlyoutMenuGlobalPosition } from '../../../components/flyout-menu/flyout-menu.component';

@Component({
  selector: 'td-wb-top-navigation-item',
  templateUrl: './top-navigation-item.component.html',
  styleUrls: ['./top-navigation-item.component.scss'],
  imports: [
    NgClass,
    FlyoutMenuToggleDirective,
    NgTemplateOutlet,
    IconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuTopGlobalNavigationItemComponent implements OnChanges, OnDestroy {

  /**
   * Navigation menu
   */
  @Input() item: MenuPanelItem;
  @Input() overlayPosition: FlyoutMenuOverlayPosition = FlyoutMenuOverlayPosition.END_BOTTOM;
  @Input() flyoutMenuUserData: FlyoutMenuComponent;
  @Input() positionStrategy: 'global' | 'flexibleConnected' = 'flexibleConnected';
  @Input() globalPosition: FlyoutMenuGlobalPosition;
  @ContentChild(MenuTopGlobalNavigationItemLabelComponent) customLabel: MenuTopGlobalNavigationItemLabelComponent;

  isFlyoutMenuOpened: boolean;
  private readonly destroy: Subject<void> = new Subject<void>();

  constructor(private changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.flyoutMenuUserData?.currentValue !== undefined) {
      outputToObservable(this.flyoutMenuUserData.open)
        .pipe(takeUntil(this.destroy))
        .subscribe((): void => this.onFlyoutMenuOpen());
      outputToObservable(this.flyoutMenuUserData.close)
        .pipe(takeUntil(this.destroy))
        .subscribe((): void => this.onFlyoutMenuClose());
    }
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  private onFlyoutMenuOpen(): void {
    this.isFlyoutMenuOpened = true;
    this.changeDetectorRef.markForCheck();
  }

  private onFlyoutMenuClose(): void {
    this.isFlyoutMenuOpened = false;
    this.changeDetectorRef.markForCheck();
  }
}
